exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-detail-container table[data-v-1d18a02c]{width:100%;border:1px solid #ddd}.service-detail-container table td[data-v-1d18a02c],.service-detail-container table th[data-v-1d18a02c]{vertical-align:middle;text-align:center;border:1px solid #ddd;padding:4px 8px}.service-detail-container table th[data-v-1d18a02c]{background-color:#f5f5f5}.service-detail-container table tr[data-v-1d18a02c]:hover{cursor:pointer;background-color:#eee}.service-detail-container .prev[data-v-1d18a02c]{background-color:#fafafa;color:#777}.button[data-v-1d18a02c]{width:50px}", ""]);

// exports
